<template>
  <div
    class="co-copy"
    :class="{ disabled: disabled, default: $slots.default }"
    @click="onCopy"
    v-if="content != null"
  >
    <slot></slot>
    <template v-if="!$slots.default">
      <span>复制</span>
    </template>
    <span class="input" ref="input">{{ content }}</span>
  </div>
</template>
<script>
export default {
  name: "co-copy",
  components: {},
  props: {
    content: [String, Number],
    title: {
      type: String,
      default: "复制成功",
    },
  },
  data() {
    return {
      disabled: false,
      timer: null,
    };
  },
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {
    onCopy() {
      if (this.disabled) return false;
      this.copy(() => {
        if (this.title) {
          this.$toast({
            message: this.title,
            type: "success",
            duration: 1500,
          });
        }
        this.disabled = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.disabled = false;
        }, 1500);
      });
    },
    copy(callback) {
      let input = this.$refs.input;
      let range = document.createRange();
      range.selectNode(input);
      let selection = window.getSelection();
      if (selection.rangeCount > 0) selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy");
      selection.removeAllRanges();
      callback && callback();
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.co-copy {
  &:not(.default) {
    border: 1px solid #e5e5e5;
    border-radius: 50px;
    margin-left: 8px;
    margin-top: -1px;
    padding: 0 8px;
    font-size: 12px;
    display: inline-block;
    cursor: pointer;
    transform: scale(0.9);
    color: #999;
    &:hover {
      opacity: 0.8;
    }
    &.disabled {
      border-color: #999;
      color: #666;
      opacity: 1;
      cursor: default;
    }
  }
  .input {
    position: fixed;
    left: 100%;
    top: -100%;
    height: 1px;
    width: 1px;
    border: none;
    overflow: hidden;
  }
}
</style>
